import { api } from './apiProvider';

export async function checkSubdomain(): Promise<void> {
  await api.get('subdomains');
}
